<template>
  <div>
    <p></p>
    <v-row v-if="showDebug">
      <v-col col="12">
        <InsightReportRawTable
          title="MS table input filtered rows (Beringar Debug Only)"
          :rows="rows"
        ></InsightReportRawTable>
      </v-col>
    </v-row>

    <v-row v-if="showDebug">
      <v-col col="12">
        <InsightReportRawTable
          title="MS table data grouped by MS (Beringar Debug Only)"
          :rows="tableValues"
        ></InsightReportRawTable>
      </v-col>
    </v-row>

    <v-card outlined>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <v-data-table
          :headers="tableHeaders"
          :items="tableValues"
          multi-sort
          dense
        ></v-data-table>
        <download-csv
          class="btn btn-default"
          :data="tableValues"
          name="filename.csv">
          <v-btn type="submit" class="my-6" block tile>Download CSV</v-btn>
        </download-csv>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import InsightReportRawTable from './InsightReportRawTable'
import reportUtil from '../lib/reportUtil'
import JsonCSV from 'vue-json-csv'

// Average Occupants When Used ave_occupant_in_used_periods
// Average Occupants When Available ave_occupant_in_all_periods
// Occupancy % When Used percent_occupancy_in_used_periods
// Occupancy % When Available percent_occupancy_all_periods
// Frequency Of Use % proportion_time_used
// Utilisation % proportion_resource_consumed

export default {
  name: 'insightreportmanagedspacetable',
  props: {
    title: String,
    rows: Array
  },
  components: {
    'downloadCsv': JsonCSV,
    InsightReportRawTable
  },
  data: () => {
    return {
      showDebug: false,
      tableHeaders: [
        {
          text: 'Managed Space Name',
          align: 'start',
          value: 'name'
        },
        {
          text: 'Floor',
          value: 'floornumber'
        },
        {
          text: 'Capacity',
          value: 'capacitypeople'
        },
        {
          text: 'Max. Occupant In Period',
          value: 'max_occupant'
        },
        {
          text: 'Average Occupants When Used',
          value: 'ave_occupant_in_used_periods'
        },
        {
          text: 'Average Occupants When Available',
          value: 'ave_occupant_in_all_periods'
        },
        {
          text: 'Occupancy % When Used',
          value: 'percent_occupancy_in_used_periods'
        },
        {
          text: 'Occupancy % When Available',
          value: 'percent_occupancy_all_periods'
        },
        {
          text: 'Frequency Of Use %',
          value: 'percent_frequency_of_use'
        },
        {
          text: 'Utilisation %',
          value: 'percentage_utilisation'
        }
      ]
    }
  },
  computed: mapState({
    tableValues: function (state) {
      // console.log('Group ms table', this.rows)
      // Group by managed space ID (group2 unused)
      let groups = reportUtil.groupX2AggregateManagedSpaceValuesReplaceNull(
        this.rows, 'managedspace_id', '', 'Ignore')
      // console.log('grouped', groups)
      reportUtil.addOccupanyAndUtililizationGroupX2(groups)
      // console.log('with utilisation', groups)
      let result = []
      // Flatten data and add MS info and delete raw data from here
      for (let outerKey in groups) {
        for (let innerKey in groups[outerKey]) {
          let row = groups[outerKey][innerKey]
          // console.log(row)
          if (this.managedSpaceDictionary) {
            let msInfo = this.managedSpaceDictionary[row.group1]
            // console.log(msInfo)
            if (msInfo) {
              row.name = msInfo.name
              row.floornumber = msInfo.floornumber
              row.capacitypeople = msInfo.capacitypeople
            }
          }
          delete row.group1
          delete row.group2
          delete row.periods_used
          delete row.periods_measured
          delete row.slots_in_all_periods
          delete row.slots_in_used_periods
          delete row.total_occupant
          result.push(row)
        }
      }
      return result
    },
    selectedBuildingInfo: state => state.building.selectedBuildingInfo,
    managedSpaceDictionary: state => state.building.managedSpaceDictionary
  })
}
</script>
